import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import AppScreen from '@/components/ui/AppScreen';
import { useMenuApp } from '@/components/feature/MenuApp';
import TopoConheca from './components/TopoConheca';
import Abertura from './components/Abertura';
import PassosConheca from './components/PassosConheca';
import TudoNumApp from './components/TudoNumApp';
import QuantoCusta from './components/QuantoCusta';
import Perguntas from './components/Perguntas';
import { SEO, WHATSAPP_URL, INSTAGRAM_URL } from './conteudo';

// /conheca — "Para organizadores". Visual de app, limpo: fundo claro, cartões
// brancos, azul da marca. Celular primeiro; no computador o menu normal fica.
export default function ConhecaPage() {
  const { organiza } = useMenuApp();

  useEffect(() => {
    const tituloAnterior = document.title;
    document.title = SEO.titulo;
    const metaExistente = document.querySelector('meta[name="description"]');
    const descricaoAnterior = metaExistente ? metaExistente.getAttribute('content') : null;
    let tag: HTMLMetaElement;
    if (metaExistente) {
      tag = metaExistente as HTMLMetaElement;
    } else {
      tag = document.createElement('meta');
      tag.setAttribute('name', 'description');
      document.head.appendChild(tag);
    }
    tag.setAttribute('content', SEO.descricao);
    return () => {
      document.title = tituloAnterior;
      if (descricaoAnterior === null) tag.parentNode?.removeChild(tag);
      else tag.setAttribute('content', descricaoAnterior);
    };
  }, []);

  return (
    <AppScreen>
      <TopoConheca />

      <main className="mx-auto w-full max-w-[560px] px-5 pb-28 pt-5 md:max-w-[680px] md:pb-16 md:pt-10">
        {organiza && (
          <div className="app-entra mb-5 flex items-center gap-3 rounded-[18px] border border-accent-200 bg-accent-50 p-4">
            <span className="flex h-5 w-5 shrink-0 items-center justify-center text-accent-600">
              <i className="ri-checkbox-circle-line text-[20px]" aria-hidden />
            </span>
            <p className="min-w-0 flex-1 text-[14px] font-semibold text-foreground-900">
              Você já organiza eventos
            </p>
            <Link
              to="/meus-eventos"
              className="aperta shrink-0 cursor-pointer whitespace-nowrap rounded-[12px] bg-primary-500 px-4 py-2 text-[13px] font-bold text-white transition-colors hover:bg-primary-600"
            >
              Ir para meus eventos
            </Link>
          </div>
        )}

        <Abertura />
        <PassosConheca />
        <TudoNumApp />
        <QuantoCusta />
        <Perguntas />

        <footer className="app-entra mt-10 flex flex-wrap items-center gap-x-5 gap-y-2" style={{ animationDelay: '300ms' }}>
          <a
            href={WHATSAPP_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="aperta inline-flex cursor-pointer items-center gap-2 whitespace-nowrap text-[14px] font-semibold text-primary-700 hover:text-primary-800"
          >
            <span className="flex h-5 w-5 items-center justify-center">
              <i className="ri-whatsapp-line text-[18px]" aria-hidden />
            </span>
            Falar no WhatsApp
          </a>
          <a
            href={INSTAGRAM_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="aperta inline-flex cursor-pointer items-center gap-2 whitespace-nowrap text-[14px] font-semibold text-foreground-600 hover:text-foreground-900"
          >
            <span className="flex h-5 w-5 items-center justify-center">
              <i className="ri-instagram-line text-[18px]" aria-hidden />
            </span>
            @seliga.catolico
          </a>
        </footer>
      </main>

      {/* Rodapé fixo no celular: atalho para criar o evento. */}
      <div
        className="fixed inset-x-0 bottom-0 z-30 border-t border-background-200 bg-background-50/95 px-5 pt-3 backdrop-blur-md md:hidden"
        style={{ paddingBottom: 'max(0.75rem, env(safe-area-inset-bottom))' }}
      >
        <Link
          to="/criar"
          className="aperta mx-auto flex h-14 w-full max-w-[560px] cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-[18px] bg-primary-500 px-6 text-[15px] font-bold text-white transition-colors hover:bg-primary-600"
        >
          <span className="flex h-5 w-5 items-center justify-center">
            <i className="ri-add-line text-[20px]" aria-hidden />
          </span>
          Criar meu evento
        </Link>
      </div>
    </AppScreen>
  );
}